import { inject, Pipe, PipeTransform } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { getAssetVersionDimensions } from '../../gallery/lib/get-asset-version-dimensions';
import { AssetDisplayService } from '../../services/asset-display.service';
import { calcContainerSizeForAsset } from '../lib/calc-container-size-for-asset';

@Pipe({
  name: 'offsetScale',
  standalone: true,
  pure: false,
})
export class OffsetScalePipe implements PipeTransform {
  private assetDisplayService = inject(AssetDisplayService);
  transform(asset: AssetDto, windowWidth: number, windowHeight: number, sideMenuOpen: boolean): number {
    const boundedContainer = this.assetDisplayService.getBoundedContainerSize(
      asset.version_data,
      calcContainerSizeForAsset(asset, windowWidth, windowHeight, sideMenuOpen)
    );
    const { width } = getAssetVersionDimensions(asset.version_data);
    return boundedContainer.width / (width || 1);
  }
}
